import { render, staticRenderFns } from "./SpecialPriceAdjDetails_Total.vue?vue&type=template&id=0933e248&"
import script from "./SpecialPriceAdjDetails_Total.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceAdjDetails_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports